import {Component, ElementRef, ViewChild} from '@angular/core';
import {AppSelectElementDirective} from '@component/form/input/select/select-element.directive';

@Component({
    selector: 'app-select-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss'],
})
export class AppSelectFilterComponent {
    #timeout?: number;

    #selectElementDirective: AppSelectElementDirective;

    @ViewChild('inputElement', {read: ElementRef})
    readonly inputElementRef!: ElementRef;

    constructor(selectElementDirective: AppSelectElementDirective) {
        this.#selectElementDirective = selectElementDirective;
    }

    handleKeyUp(event: Event): void {
        window.clearTimeout(this.#timeout);
        this.#timeout = window.setTimeout(() => this.#handleFilterInput(), 250);

        return;
    }

    #handleFilterInput(): void {
        const inputElement: HTMLInputElement = this.inputElementRef.nativeElement;

        this.#selectElementDirective.filter(inputElement.value);
    }
}
